








































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import format from 'date-fns/format';

import DownloadButton from '@/components/DownloadButton/DownloadButton.vue';

@Component({
  components: {
    DownloadButton,
  },
})
export default class AppRouteHeader extends Vue {
  @Prop({ default: true })
  loading!: boolean;

  @Prop({ default: 0 })
  totalReleases!: number;

  @Prop({ default: {} })
  releaseData!: AppStore.Release;

  isIntersecting = false;

  releaseTime(date: string): string {
    const parsedDate = new Date(date);
    return format(parsedDate, 'MMMM do yyyy');
  }

  onIntersect(entries: IntersectionObserverEntry[]) {
    this.isIntersecting = entries[0].isIntersecting;
  }
}
